import { useEffect, useState } from "react";
import IotDetails from "../../components/ThirdPartyDashboard/IotDetails";
import SideBar from "../../components/ThirdPartyDashboard/SideBar";
import "../../styles/ThirdParty/Iot.scss";
import {
  getDatabase,
  ref,
  onValue,
  orderByChild,
  equalTo,
  query,
} from "firebase/database";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate, useParams } from "react-router-dom";
import Search from "../../components/ThirdPartyDashboard/Search";
import { Tooltip, Typography } from "@mui/material";
import isTimestampWithinHourAndTenMinutes from "../../utils/iotUptime";

const LivestockIOT = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [devices, setDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deviceUptimes, setDeviceUptimes] = useState({});
  const [deviceBatteryLevel, setDeviceBatteryLevel] = useState({});

  const navigate = useNavigate();
  const { id } = useParams();

  const db = getDatabase();
  const tableRef = ref(db, "sensors");

  const handleModalClose = () => setModalOpen(false);

  useEffect(() => {
    if (!id) return;

    setLoading(true);

    const deviceQuery = query(
      tableRef,
      orderByChild("device_id"),
      equalTo(id)
    );

    const unsubscribe = onValue(
      deviceQuery,
      (snapshot) => {
        if (!snapshot.exists()) {
          setDevices([]);
          setDeviceUptimes({});
          setDeviceBatteryLevel({});
          setLoading(false);
          return;
        }

        const rawData = snapshot.val();

        const mappedDevices = Object.entries(rawData).map(([key, value]) => {
          const timestamp =
            value.created_at ||
            value.createdAt ||
            value.timestamp ||
            0;

          return {
            firebaseKey: key,
            deviceId: value.device_id,
            createdAt: Number(timestamp),
            battery:
              Number(value.battery || value.battery_level) || 0,
          };
        });

        // Sort newest first
        const sorted = mappedDevices.sort(
          (a, b) => b.createdAt - a.createdAt
        );

        // Build uptime & battery maps
        const uptimeMap = {};
        const batteryMap = {};

        sorted.forEach((device) => {
          uptimeMap[device.deviceId] =
            isTimestampWithinHourAndTenMinutes(
              device.createdAt
            );
          batteryMap[device.deviceId] = device.battery;
        });

        setDevices(sorted);
        setDeviceUptimes(uptimeMap);
        setDeviceBatteryLevel(batteryMap);
        setLoading(false);
      },
      (error) => {
        console.error("Firebase error:", error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [id]);

  return (
    <div className="iot">
      <div className="sidebar_container">
        <SideBar />
      </div>

      <div className="main">
        <Search />
        <div className="title">IoT Devices</div>

        {loading && (
          <div className="grid">
            {Array.from({ length: 4 }).map((_, i) => (
              <div className="card" key={i}>
                <Skeleton height={120} />
              </div>
            ))}
          </div>
        )}

        <div className="grid">
          {devices.map((device) => {
            const isValidTimestamp =
              !isNaN(device.createdAt) &&
              device.createdAt > 0;

            return (
              <div
                className="card"
                key={device.firebaseKey}
              >
                <div className="grid_inner">
                  <div className="subtitle bold">
                    Sensor ID:
                  </div>
                  <div>{device.deviceId}</div>
                </div>

                <div className="flex">
                  <div className="flex_inner">
                    <div>
                      {isValidTimestamp
                        ? moment(device.createdAt).format(
                            "hh:mm A"
                          )
                        : "N/A"}
                    </div>
                  </div>

                  <div className="flex_inner">
                    <div>
                      {isValidTimestamp
                        ? moment(device.createdAt).format(
                            "Do MMM YYYY"
                          )
                        : "N/A"}
                    </div>
                  </div>
                </div>

                <div
                  className="more pointer bold"
                  onClick={() =>
                    navigate("/livestockIOTDate")
                  }
                >
                  View more
                </div>

                <Tooltip
                  title={
                    <Typography variant="h6">
                      {deviceUptimes[
                        device.deviceId
                      ]
                        ? "IoT device is active"
                        : "IoT device is offline"}
                    </Typography>
                  }
                >
                  <div
                    className={
                      deviceUptimes[
                        device.deviceId
                      ]
                        ? "card__indicator card__indicator-active"
                        : "card__indicator card__indicator-inactive"
                    }
                  />
                </Tooltip>

                <div className="card__battery-level">
                  Battery level:
                  <span>
                    {" "}
                    {deviceBatteryLevel[
                      device.deviceId
                    ] ?? 0}
                    %
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        {modalOpen && (
          <IotDetails
            handlModalClose={handleModalClose}
            device={selectedDevice}
          />
        )}
      </div>
    </div>
  );
};

export default LivestockIOT;
